import { Outlet, useLocation } from "react-router-dom";
import AnnouncementBar from "./AnnouncementBar";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import { cn } from "@/utils/cn";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const transparent = pathname === "/";

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <AnnouncementBar />
      <PublicHeader transparent={transparent} />
      <main className={cn("flex-1", !transparent && "pt-[104px]")}>
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}